module.exports = __webpack_public_path__ + "intellinote.3b9704.svg";